import React, { useEffect, useRef } from "react";
import {
  I2cInput,
  I2cRadio,
  I2cRadioButton,
  I2cRadioGroup,
  I2cCheckboxGroup,
  I2cListItem,
  I2cCheckbox,
  I2cTooltip,
  I2cTextarea,
  I2cPhoneField,
  I2cIcon,
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../Prepaid.scss";
import * as Yup from "yup";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { emailAdressValidator } from "../../../Utils/stringUtls";

export const consumerFundingSource = [
  {
    label: "Retail load networks in cash",
    value: "retail-load-networks-in-cash",
  },
  {
    label: "Load from payment card (credit or debit)",
    value: "credit-or-debit",
  },
  {
    label: "Load from bank account (B2C ACH)",
    value: "from-bank-account",
  },
  { label: "Direct deposit", value: "direct-deposit" },
];
export const corporateFundingSource = [
  { label: "ACH/Electronic transfer", value: "electronic-transfer" },
  { label: "Others", value: "other" },
];
export const cardPlacement = [
  {
    label: "Cardholders will place an order for individual cards",
    value: "individual-cards",
    supportText:
      "Card holders can use C-Cart or WebPOS to place orders for a single card",
  },
  {
    label: "Program Managers/Partners will bulk order cards",
    value: "bulk-order-cards",
    supportText:
      "Bulk card order requests can be sent in through the Partner Portal (C-Partner), Batch File (CH-Auth Batch) or API.",
  },
];
export const cardChannelIndividual = [
  { label: "Bulk Uploads", value: "bulk-uploads" },
  { label: "C-Partner", value: "c-partner" },
  { label: "Order from retail WebPOS", value: "web-pos" },
  { label: "APIs", value: "apis" },
];
export const cardChannelBulk = [
  {
    label: "Bulk uploads through a batch file (CH-Auth File)",
    value: "bulk-uploads",
  },
  { label: "C-Partner", value: "c-partner" },
  { label: "APIs", value: "apis" },
];
export const cardsActivationChannel = [
  { label: "IVR", value: "ivr" },
  { label: "Live operator", value: "live-operator" },
  { label: "Cardholder website", value: "cardholder-website" },
  { label: "Mobile app", value: "mobile-app" },
  { label: "WebPOS", value: "web-pos" },
  { label: "API", value: "api" },
  { label: "Other", value: "other" },
];
export const customerSupportChannel = [
  { label: "IVR", value: "ivr" },
  { label: "Live Agent Support (Call Agent)", value: "live-agent" },
];
export const cardholderNotify = [
  { label: "Send alerts to Cardholders", value: "send-to-holders" },
  {
    label: "Send alerts data to Program Managers",
    value: "send-to-managers",
  },
];
export const customerSupportProviders = [
  { label: "i2c Inc", value: "i2c" },
  {
    label: "Client/Third Party",
    value: "client-third-party",
  },
];
export const notificationChannels = [
  { label: "Email Alerts", value: "email-alerts" },
  { label: "Text Alerts", value: "text-alerts" },
  { label: "Push Notifications", value: "push-notification" },
];
export const kycResponsibility = [
  {
    label: "Managed by the i2c platform, based upon program settings",
    value: "managed-by-the-i2c-platform-based-upon-program-settings",
  },
  {
    label: "Managed-by-Issuer/ISO/Sponsor-Bank",
    value: "managed-by-issuer-iso-sponsor-bank",
  },
  {
    label: "Other",
    value: "other",
  },
];
export const cardActivationMethod = [
  { label: "Activation on first load", value: "on-first-load" },
  { label: "Generate Activated Cards", value: "generate-activated" },
];
const ProgramFeatures = ({
  setAddFormData,
  addFormData,
  setFormValidStates,
  formDataJson,
  isFetching,
}) => {
  const cardActivation = useRef(null);
  const keyProcess = ["Yes", "No"];

  const fundingSource = [
    {
      label: "Loaded by the consumer through",
      value: "loaded-by-the-consumer-through",
    },
    {
      label: "Loaded by a corporate entity through",
      value: "loaded-by-a-corporate-entity-through",
    },
  ];

  const secondaryCardOption = ["Yes", "No"];
  const shareBalance = ["Yes", "No"];
  const ownProfile = ["Yes", "No"];
  const offlinePin = ["Yes", "No"];
  const handleCardActivationChannel = (event) => {
    let selectedChannels;
    if (!event.length) selectedChannels = event.target.value;
    else selectedChannels = event;
    let updatedCardsActivationChannel = methods.watch(
      "pf_card_activation_channels",
    );
    if (updatedCardsActivationChannel.includes(selectedChannels)) {
      // If the card is already selected, remove it
      updatedCardsActivationChannel = updatedCardsActivationChannel.filter(
        (card) => card !== selectedChannels,
      );
    } else {
      // If the card is not selected, add it
      updatedCardsActivationChannel.push(selectedChannels);
    }

    methods.setValue(
      "pf_card_activation_channels",
      updatedCardsActivationChannel,
    );
    methods.trigger();
    if (!updatedCardsActivationChannel.includes("other"))
      methods.clearErrors("pf_card_activation_channels_other");
    else if (!methods.getValues("pf_card_activation_channels_other").length)
      methods.setError("pf_card_activation_channels_other", {
        message: generalErrorMessage,
      });

    if (updatedCardsActivationChannel.length)
      methods.clearErrors("pf_card_activation_channels");
    else
      methods.setError("pf_card_activation_channels", {
        message: "At least one network must be selected",
      });
  };

  const handleCustomerSupportChannels = (event) => {
    let selectedChannels;
    if (!event.length) selectedChannels = event.target.value;
    else selectedChannels = event;
    let updatedCardsActivationChannel = methods.watch(
      "pf_customer_support_channels",
    );
    if (updatedCardsActivationChannel.includes(selectedChannels)) {
      // If the card is already selected, remove it
      updatedCardsActivationChannel = updatedCardsActivationChannel.filter(
        (card) => card !== selectedChannels,
      );
    } else {
      // If the card is not selected, add it
      updatedCardsActivationChannel.push(selectedChannels);
    }

    methods.setValue(
      "pf_customer_support_channels",
      updatedCardsActivationChannel,
    );
    methods.trigger();
    handleValueChanges();
  };

  const generalErrorMessage = "Please fill out this field.";
  const validationSchema = Yup.object({
    pf_enable_kyc_conduct: Yup.string()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),
    pf_kyc_conduct: Yup.string().when("pf_enable_kyc_conduct", {
      is: (enable_kyc) => enable_kyc === "yes",
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    pf_kyc_conduct_other_company: Yup.string().when("pf_kyc_conduct", {
      is: (kyc_conduts) => kyc_conduts === "other",
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    pf_kyc_conduct_other_contact_name: Yup.string().when("pf_kyc_conduct", {
      is: (kyc_conduts) => kyc_conduts === "other",
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    pf_kyc_conduct_other_title: Yup.string().when("pf_kyc_conduct", {
      is: (kyc_conduts) => kyc_conduts === "other",
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    pf_kyc_conduct_other_phone: Yup.string().when("pf_kyc_conduct", {
      is: (kyc_conduts) => kyc_conduts === "other",
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    pf_kyc_conduct_other_email: Yup.string().when("pf_kyc_conduct", {
      is: (kyc_conduts) => kyc_conduts === "other",
      then: () =>
        Yup.string()
          .required(generalErrorMessage)
          .test("", "", function (item) {
            // this.parent gives the whole parent
            return emailAdressValidator(item);
          }),
      otherwise: () => Yup.string().optional(),
    }),
    pf_kyc_conduct_other_address: Yup.string().when("pf_kyc_conduct", {
      is: (kyc_conduts) => kyc_conduts === "other",
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    pf_funding_source_consumer_option: Yup.array().optional(),

    pf_funding_source_corporate_option: Yup.string()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),

    pf_funding_source_corporate_other_company: Yup.string().when(
      "pf_funding_source_corporate_option",
      {
        is: (pf_funding_source_corporate_option) =>
          pf_funding_source_corporate_option === "other",
        then: () =>
          Yup.string()
            .required(generalErrorMessage)
            .min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
      },
    ),
    pf_funding_source_corporate_other_contact_name: Yup.string().when(
      "pf_funding_source_corporate_option",
      {
        is: (pf_funding_source_corporate_option) =>
          pf_funding_source_corporate_option === "other",
        then: () =>
          Yup.string()
            .required(generalErrorMessage)
            .min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
      },
    ),
    pf_funding_source_corporate_other_title: Yup.string().when(
      "pf_funding_source_corporate_option",
      {
        is: (pf_funding_source_corporate_option) =>
          pf_funding_source_corporate_option === "other",
        then: () =>
          Yup.string()
            .required(generalErrorMessage)
            .min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
      },
    ),
    pf_funding_source_corporate_other_phone: Yup.string().when(
      "pf_funding_source_corporate_option",
      {
        is: (pf_funding_source_corporate_option) =>
          pf_funding_source_corporate_option === "other",
        then: () =>
          Yup.string()
            .required(generalErrorMessage)
            .min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
      },
    ),
    pf_funding_source_corporate_other_email: Yup.string().when(
      "pf_funding_source_corporate_option",
      {
        is: (pf_funding_source_corporate_option) =>
          pf_funding_source_corporate_option === "other",
        then: () =>
          Yup.string()
            .required(generalErrorMessage)
            .test("", "", function (item) {
              // this.parent gives the whole parent
              return emailAdressValidator(item);
            }),
        otherwise: () => Yup.string().optional(),
      },
    ),
    pf_funding_source_corporate_other_address: Yup.string().when(
      "pf_funding_source_corporate_option",
      {
        is: (pf_funding_source_corporate_option) =>
          pf_funding_source_corporate_option === "other",
        then: () =>
          Yup.string()
            .required(generalErrorMessage)
            .min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
      },
    ),

    pf_card_placement: Yup.string()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),
    pf_card_placement_channel: Yup.array()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),
    pf_supplimentary_cards_permitted: Yup.string()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),
    pf_supplimentary_cards_age_limit: Yup.string()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),
    supplimentary_cards_own_profile: Yup.string().when(
      "pf_supplimentary_cards_permitted",
      {
        is: (sup_card_permitted) => sup_card_permitted === "yes",
        then: () =>
          Yup.string()
            .required(generalErrorMessage)
            .min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
      },
    ),
    supplimentary_cards_share_primary_balance: Yup.string().when(
      "pf_supplimentary_cards_permitted",
      {
        is: (sup_card_permitted) => sup_card_permitted === "yes",
        then: () =>
          Yup.string()
            .required(generalErrorMessage)
            .min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
      },
    ),
    pf_card_activation_required: Yup.string()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),
    pf_card_activation_method: Yup.string().when(
      "pf_card_activation_required",
      {
        is: (pf_card_activation_required) =>
          pf_card_activation_required === "no",
        then: () =>
          Yup.string()
            .required(generalErrorMessage)
            .min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
      },
    ),
    pf_card_activation_channels: Yup.array().when(
      "pf_card_activation_required",
      {
        is: (pf_card_activation_required) =>
          pf_card_activation_required === "yes",
        then: () =>
          Yup.array().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.array().optional(),
      },
    ),
    pf_card_activation_channels_other: Yup.string().when(
      "pf_card_activation_channels",
      {
        is: (pf_card_activation_channels) =>
          pf_card_activation_channels?.includes("other"),
        then: () =>
          Yup.string()
            .required(generalErrorMessage)
            .min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
      },
    ),
    pf_card_offline_pin_required: Yup.string()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),
    pf_cardholder_notifications: Yup.string()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),
    pf_cardholder_notifications_channels: Yup.string()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),

    pf_customer_support_channels: Yup.array().optional(),

    pf_customer_support_provider: Yup.string()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),
    pf_customer_support_provider_other_company: Yup.string().when(
      "pf_customer_support_provider",
      {
        is: (support_provider) => support_provider === "client-third-party",
        then: () =>
          Yup.string()
            .required(generalErrorMessage)
            .min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
      },
    ),
    pf_customer_support_provider_other_contact_name: Yup.string().when(
      "pf_customer_support_provider",
      {
        is: (support_provider) => support_provider === "client-third-party",
        then: () =>
          Yup.string()
            .required(generalErrorMessage)
            .min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
      },
    ),
    pf_customer_support_provider_other_title: Yup.string().when(
      "pf_customer_support_provider",
      {
        is: (support_provider) => support_provider === "client-third-party",
        then: () =>
          Yup.string()
            .required(generalErrorMessage)
            .min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
      },
    ),
    pf_customer_support_provider_other_phone: Yup.string().when(
      "pf_customer_support_provider",
      {
        is: (support_provider) => support_provider === "client-third-party",
        then: () =>
          Yup.string()
            .required(generalErrorMessage)
            .min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
      },
    ),
    pf_customer_support_provider_other_email: Yup.string().when(
      "pf_customer_support_provider",
      {
        is: (support_provider) => support_provider === "client-third-party",
        then: () =>
          Yup.string()
            .required(generalErrorMessage)
            .test("", "", function (item) {
              // this.parent gives the whole parent
              return emailAdressValidator(item);
            }),
        otherwise: () => Yup.string().optional(),
      },
    ),
  });

  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: {
      pf_enable_kyc_conduct: "",
      pf_kyc_conduct: "",
      pf_kyc_conduct_other_company: "",
      pf_kyc_conduct_other_contact_name: "",
      pf_kyc_conduct_other_title: "",
      pf_kyc_conduct_other_phone: "",
      pf_kyc_conduct_other_phone_country: "",
      pf_kyc_conduct_other_email: "",
      pf_kyc_conduct_other_address: "",
      pf_funding_source_consumer_option: [],
      pf_funding_source_corporate_option: "",
      pf_funding_source_corporate_other_company: "",
      pf_funding_source_corporate_other_contact_name: "",
      pf_funding_source_corporate_other_title: "",
      pf_funding_source_corporate_other_phone: "",
      pf_funding_source_corporate_other_phone_country: "",
      pf_funding_source_corporate_other_email: "",
      pf_funding_source_corporate_other_address: "",
      pf_card_placement: "",
      pf_card_placement_channel: [],
      pf_supplimentary_cards_permitted: "",
      pf_supplimentary_cards_age_limit: "",
      supplimentary_cards_own_profile: "",
      supplimentary_cards_share_primary_balance: "",
      pf_card_activation_required: "",
      pf_card_activation_method: "",
      pf_card_activation_channels: [],
      pf_card_activation_channels_other: "",
      pf_card_offline_pin_required: "",
      pf_cardholder_notifications: "",
      pf_cardholder_notifications_channels: "",
      pf_customer_support_channels: [],
      pf_customer_support_provider: "",
      pf_customer_support_provider_other_company: "",
      pf_customer_support_provider_other_contact_name: "",
      pf_customer_support_provider_other_title: "",
      pf_customer_support_provider_other_phone: "",
      pf_customer_support_provider_other_phone_country: "",
      pf_customer_support_provider_other_email: "",
    },
  });

  // Controlls destructuring from the method
  const {
    control,
    formState: { errors },
  } = methods;

  const fields = [
    "pf_enable_kyc_conduct",
    "pf_kyc_conduct",
    "pf_kyc_conduct_other_company",
    "pf_kyc_conduct_other_contact_name",
    "pf_kyc_conduct_other_title",
    "pf_kyc_conduct_other_phone",
    "pf_kyc_conduct_other_phone_country",
    "pf_kyc_conduct_other_email",
    "pf_kyc_conduct_other_address",
    "pf_funding_source_consumer_option",
    "pf_funding_source_corporate_option",
    "pf_funding_source_corporate_other_company",
    "pf_funding_source_corporate_other_contact_name",
    "pf_funding_source_corporate_other_title",
    "pf_funding_source_corporate_other_phone",
    "pf_funding_source_corporate_other_phone_country",
    "pf_funding_source_corporate_other_email",
    "pf_funding_source_corporate_other_address",
    "pf_card_placement",
    "pf_card_placement_channel",
    "pf_supplimentary_cards_permitted",
    "pf_supplimentary_cards_age_limit",
    "supplimentary_cards_own_profile",
    "supplimentary_cards_share_primary_balance",
    "pf_card_activation_required",
    "pf_card_activation_method",
    "pf_card_activation_channels",
    "pf_card_activation_channels_other",
    "pf_card_offline_pin_required",
    "pf_cardholder_notifications",
    "pf_cardholder_notifications_channels",
    "pf_customer_support_channels",
    "pf_customer_support_provider",
    "pf_customer_support_provider_other_company",
    "pf_customer_support_provider_other_contact_name",
    "pf_customer_support_provider_other_title",
    "pf_customer_support_provider_other_phone",
    "pf_customer_support_provider_other_phone_country",
    "pf_customer_support_provider_other_email",
  ];
  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      fields.forEach((field) => {
        methods.setValue(field, formDataJson[5]["5_0"][field] ?? "");
      });
      methods.trigger();
    }
  }, [isFetching]);

  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, []);

  const handleValueChanges = () => {
    const values = methods.getValues();
    setAddFormData({
      ...addFormData,
      5: {
        ...addFormData["5"],
        "5_0": { ...values },
      },
    });
  };

  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors).length;
    if (errorsLength === 0) setFormValidStates("5_0", true);
    else setFormValidStates("5_0", false);
    handleValueChanges();
  }, [Object.keys(errors).length]);

  const handleConsumerCheckboxGroupChange = (event) => {
    let selectedOptions;
    if (!event.length) selectedOptions = event.target.value;
    else selectedOptions = event;
    let updatedSelectedOptions = [
      ...(methods.getValues("pf_funding_source_consumer_option") ?? []),
    ];
    if (updatedSelectedOptions.includes(selectedOptions)) {
      // If the card is already selected, remove it
      updatedSelectedOptions = updatedSelectedOptions.filter(
        (card) => card !== selectedOptions,
      );
    } else {
      // If the card is not selected, add it
      updatedSelectedOptions.push(selectedOptions);
    }
    methods.setValue(
      "pf_funding_source_consumer_option",
      updatedSelectedOptions,
    );
    methods.trigger();
    handleValueChanges();
  };

  const handleIndividualsCheckboxGroupChange = (event) => {
    let selectedOptions;
    if (!event.length) selectedOptions = event.target.value;
    else selectedOptions = event;
    let updatedSelectedOptions = [
      ...(methods.getValues("pf_card_placement_channel") ?? []),
    ];
    if (updatedSelectedOptions.includes(selectedOptions)) {
      // If the card is already selected, remove it
      updatedSelectedOptions = updatedSelectedOptions.filter(
        (card) => card !== selectedOptions,
      );
    } else {
      // If the card is not selected, add it
      updatedSelectedOptions.push(selectedOptions);
    }
    methods.setValue("pf_card_placement_channel", updatedSelectedOptions);
    methods.trigger();
    if (updatedSelectedOptions.length)
      methods.clearErrors("pf_card_placement_channel");
    else
      methods.setError("pf_card_placement_channel", {
        message: "At least one source must be selected",
      });
  };
  return (
    <React.Fragment>
      <div className="forms-instance">
        <div i2c-grid="grid gap-md" className="section-space">
          <div i2c-grid="12">
            <div className="inner_step_title  mb-4">
              Card Holder Authentication
            </div>
            <div className="custom-label-light mb-16">
              Would you like KYC enabled for this program?
            </div>
            <I2cRadioGroup
              onI2cChange={(e) => {
                if (e.target.value === "no") {
                  methods.setValue("pf_kyc_conduct", "");
                  methods.setValue("pf_kyc_conduct_other_company", "");
                  methods.setValue("pf_kyc_conduct_other_contact_name", "");
                  methods.setValue("pf_kyc_conduct_other_title", "");
                  methods.setValue("pf_kyc_conduct_other_phone", "");
                  methods.setValue("pf_kyc_conduct_other_phone_country", "");
                  methods.setValue("pf_kyc_conduct_other_email", "");
                  methods.setValue("pf_kyc_conduct_other_address", "");
                }
                methods.setValue("pf_enable_kyc_conduct", e.target.value);
                methods.trigger();
                handleValueChanges();
              }}
            >
              {keyProcess.map((radio, index) => (
                <I2cRadioButton
                  key={index}
                  checked={
                    methods.watch("pf_enable_kyc_conduct") ===
                    radio.toLocaleLowerCase()
                  }
                  value={radio.toLocaleLowerCase()}
                  label={radio}
                >
                  {radio}
                </I2cRadioButton>
              ))}
            </I2cRadioGroup>
          </div>
          {methods.watch("pf_enable_kyc_conduct") === "yes" && (
            <>
              <div i2c-grid="12">
                <div className="sub-heading mb-4">Who will conduct KYC?</div>
                <div className="single-field-wrapper">
                  <Controller
                    name="pf_kyc_conduct"
                    control={control}
                    render={({ field }) => (
                      <I2cRadioGroup
                        {...field}
                        className="centeredCheckbox"
                        label="Who will conduct KYC?"
                        onI2cChange={(e) => {
                          methods.setValue("pf_kyc_conduct", e.target.value);
                          if (e.target.value !== "other") {
                            methods.setValue(
                              "pf_kyc_conduct_other_company",
                              "",
                            );
                            methods.setValue(
                              "pf_kyc_conduct_other_contact_name",
                              "",
                            );
                            methods.setValue("pf_kyc_conduct_other_title", "");
                            methods.setValue("pf_kyc_conduct_other_phone", "");
                            methods.setValue(
                              "pf_kyc_conduct_other_phone_country",
                              "",
                            );
                            methods.setValue("pf_kyc_conduct_other_email", "");
                            methods.setValue(
                              "pf_kyc_conduct_other_address",
                              "",
                            );
                          }
                          methods.trigger();
                          handleValueChanges();
                        }}
                      >
                        <div i2c-grid="grid gap-sm">
                          {kycResponsibility.map((card, index) => (
                            <I2cListItem
                              key={index}
                              i2c-grid="6@md"
                              variant="receipt"
                              label={card.label}
                              sublabel=""
                              value=""
                              type="checkbox"
                              checked={
                                methods.watch("pf_kyc_conduct") === card.value
                              }
                            >
                              <I2cRadio
                                slot="prefix"
                                filled
                                checked={
                                  methods.watch("pf_kyc_conduct") === card.value
                                }
                                value={card.value}
                              ></I2cRadio>
                            </I2cListItem>
                          ))}
                        </div>
                      </I2cRadioGroup>
                    )}
                  />
                  <ErrorMessage
                    show={
                      errors.pf_kyc_conduct &&
                      methods.formState.touchedFields.pf_kyc_conduct
                        ? true
                        : false
                    }
                    message={errors.pf_kyc_conduct?.message ?? "Invalid input"}
                  />
                </div>
              </div>
              {methods.watch("pf_kyc_conduct") === "other" && (
                <div key={"pf_kyc_conduct-other"} i2c-grid="12">
                  <div className="custom-label-light mb-12">
                    If using a 3rd Party Vendor, please provide details:
                  </div>
                  <div i2c-grid="grid gap-column-sm gap-row-md">
                    <div i2c-grid="6@md">
                      <div className="single-field-wrapper">
                        <Controller
                          name="pf_kyc_conduct_other_company"
                          control={control}
                          render={({ field }) => (
                            <I2cInput
                              {...field}
                              name={"pf_kyc_conduct_other_company"}
                              className="single-input-field"
                              placeholder="Company Name"
                              onI2cInput={(e) => {
                                const value = e.target.value;
                                field.onChange(value);
                                methods.trigger();
                                handleValueChanges();
                                if (value.length === 0) {
                                  methods.setError(
                                    "pf_kyc_conduct_other_company",
                                    {
                                      message: generalErrorMessage,
                                    },
                                  );
                                } else {
                                }
                              }}
                              required={
                                errors.pf_kyc_conduct_other_company
                                  ? true
                                  : false
                              }
                              size="large"
                              label="Company Name"
                            />
                          )}
                        />
                        {/* <ErrorMessage
                          show={
                            errors.pf_kyc_conduct_other_company &&
                            methods.formState.touchedFields
                              .pf_kyc_conduct_other_company
                              ? true
                              : false
                          }
                          message={
                            errors.pf_kyc_conduct_other_company?.message ??
                            "Invalid input"
                          }
                        /> */}
                      </div>
                    </div>
                    <div i2c-grid="6@md">
                      <div className="single-field-wrapper">
                        <Controller
                          name="pf_kyc_conduct_other_contact_name"
                          control={control}
                          render={({ field }) => (
                            <I2cInput
                              {...field}
                              name={"pf_kyc_conduct_other_contact_name"}
                              className="single-input-field"
                              placeholder="Contact Name"
                              onI2cInput={(e) => {
                                const value = e.target.value;
                                field.onChange(value);
                                methods.trigger();
                                handleValueChanges();
                                if (value.length === 0) {
                                  methods.setError(
                                    "pf_kyc_conduct_other_contact_name",
                                    {
                                      message: generalErrorMessage,
                                    },
                                  );
                                } else {
                                }
                              }}
                              required={
                                errors.pf_kyc_conduct_other_contact_name
                                  ? true
                                  : false
                              }
                              size="large"
                              label="Contact Name"
                            />
                          )}
                        />
                        {/* <ErrorMessage
                          show={
                            errors.pf_kyc_conduct_other_contact_name &&
                            methods.formState.touchedFields
                              .pf_kyc_conduct_other_contact_name
                              ? true
                              : false
                          }
                          message={
                            errors.pf_kyc_conduct_other_contact_name?.message ??
                            "Invalid input"
                          }
                        /> */}
                      </div>
                    </div>
                    <div i2c-grid="6@md">
                      <div className="single-field-wrapper">
                        <Controller
                          name="pf_kyc_conduct_other_title"
                          control={control}
                          render={({ field }) => (
                            <I2cInput
                              {...field}
                              name={"pf_kyc_conduct_other_title"}
                              className="single-input-field"
                              placeholder="Job Title"
                              onI2cInput={(e) => {
                                const value = e.target.value;
                                field.onChange(value);
                                methods.trigger();
                                handleValueChanges();
                                if (value.length === 0) {
                                  methods.setError(
                                    "pf_kyc_conduct_other_title",
                                    {
                                      message: generalErrorMessage,
                                    },
                                  );
                                } else {
                                }
                              }}
                              required={
                                errors.pf_kyc_conduct_other_title ? true : false
                              }
                              size="large"
                              label="Job Title"
                            />
                          )}
                        />
                        {/* <ErrorMessage
                          show={
                            errors.pf_kyc_conduct_other_title &&
                            methods.formState.touchedFields
                              .pf_kyc_conduct_other_title
                              ? true
                              : false
                          }
                          message={
                            errors.pf_kyc_conduct_other_title?.message ??
                            "Invalid input"
                          }
                        /> */}
                      </div>
                    </div>
                    <div i2c-grid="6@md">
                      <div className="single-field-wrapper">
                        <I2cPhoneField
                          format="INTERNATIONAL"
                          label="Phone"
                          helpIcon=""
                          name="pf_kyc_conduct_other_phone"
                          size="large"
                          country-box
                          value={methods.watch("pf_kyc_conduct_other_phone")}
                          selectedCountry={methods.watch(
                            "pf_kyc_conduct_other_phone_country",
                          ) || "US"}
                          errorMessageVisible={false}
                          onI2cChange={(e) => {
                            const country = e.target.country;
                            const isValid = e.target.isValid;
                            const value = e.target.value;
                            methods.setValue(
                              "pf_kyc_conduct_other_phone_country",
                              country,
                            );
                            methods.setValue(
                              "pf_kyc_conduct_other_phone",
                              value,
                            );
                            methods.trigger();
                            handleValueChanges();
                            if (!isValid) {
                              methods.setError("pf_kyc_conduct_other_phone", {
                                message: e.target.guide,
                              });
                            } else {
                              methods.clearErrors("pf_kyc_conduct_other_phone");
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div i2c-grid="6@md">
                      <div className="single-field-wrapper">
                        <Controller
                          name="pf_kyc_conduct_other_email"
                          control={control}
                          render={({ field }) => (
                            <I2cInput
                              {...field}
                              name={"pf_kyc_conduct_other_email"}
                              className="single-input-field"
                              placeholder="Email"
                              onI2cInput={(e) => {
                                const value = e.target.value;
                                field.onChange(value);
                                methods.trigger();
                                handleValueChanges();
                                if (value.length === 0) {
                                  methods.setError(
                                    "pf_kyc_conduct_other_email",
                                    {
                                      message: generalErrorMessage,
                                    },
                                  );
                                } else {
                                }
                              }}
                              required={
                                errors.pf_kyc_conduct_other_email ? true : false
                              }
                              type="email"
                              size="large"
                              label="Email"
                            />
                          )}
                        />
                        {/* <ErrorMessage
                          show={
                            errors.pf_kyc_conduct_other_email &&
                            methods.formState.touchedFields
                              .pf_kyc_conduct_other_email
                              ? true
                              : false
                          }
                          message={
                            errors.pf_kyc_conduct_other_email?.message ??
                            "Invalid input"
                          }
                        /> */}
                      </div>
                    </div>
                    <div i2c-grid="6@md">
                      <div className="single-field-wrapper">
                        <Controller
                          name="pf_kyc_conduct_other_address"
                          control={control}
                          render={({ field }) => (
                            <I2cTextarea
                              {...field}
                              name={"pf_kyc_conduct_other_address"}
                              className="single-input-field"
                              placeholder="Physical Address"
                              onI2cInput={(e) => {
                                const value = e.target.value;
                                field.onChange(value);
                                methods.trigger();
                                handleValueChanges();
                                if (value.length === 0) {
                                  methods.setError(
                                    "pf_kyc_conduct_other_address",
                                    {
                                      message: generalErrorMessage,
                                    },
                                  );
                                } else {
                                }
                              }}
                              required={
                                errors.pf_kyc_conduct_other_address
                                  ? true
                                  : false
                              }
                              size="large"
                              label="Physical Address"
                              rows={2}
                            />
                          )}
                        />
                        <ErrorMessage
                          show={
                            errors.pf_kyc_conduct_other_address &&
                            methods.formState.touchedFields
                              .pf_kyc_conduct_other_address
                              ? true
                              : false
                          }
                          message={
                            errors.pf_kyc_conduct_other_address?.message ??
                            "Invalid input"
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
        <div i2c-grid="grid gap-md" className="section-space">
          <div i2c-grid="12">
            <div className="sub-heading mb-4">Funding Source for the Cards</div>
            <div className="custom-label-light">
              Select the relevant card funding options to confirm who will fund
              the cards and how they will be funded
            </div>
          </div>
          <div i2c-grid="12">
            <div className="custom-label-light mb-16">
              Loaded by the consumer through
            </div>
            <div className="single-field-wrapper">
              <Controller
                name="pf_funding_source_consumer_option"
                control={control}
                render={({ field }) => (
                  <I2cCheckboxGroup
                    {...field}
                    className="centeredCheckbox"
                    label=""
                  >
                    <div i2c-grid="grid gap-sm">
                      {consumerFundingSource.map((card, index) => (
                        <I2cListItem
                          key={index}
                          i2c-grid="6@md"
                          variant="receipt"
                          label={card.label}
                          sublabel=""
                          value=""
                          type="checkbox"
                          checked={
                            methods
                              .watch("pf_funding_source_consumer_option")
                              ?.includes(card.value) ?? false
                          }
                          onI2cCheckboxClicked={(e) => {
                            handleConsumerCheckboxGroupChange(card.value);
                          }}
                        >
                          <I2cCheckbox
                            slot="prefix"
                            filled
                            value={card.value}
                            checked={
                              methods
                                .watch("pf_funding_source_consumer_option")
                                ?.includes(card.value) ?? false
                            }
                            // onI2cChange={(e) => {
                            //   handleConsumerCheckboxGroupChange(e);
                            // }}
                            
                          ></I2cCheckbox>
                        </I2cListItem>
                      ))}
                    </div>
                  </I2cCheckboxGroup>
                )}
              />
              <ErrorMessage
                show={
                  errors.pf_funding_source_consumer_option &&
                  methods.formState.touchedFields
                    .pf_funding_source_consumer_option
                    ? true
                    : false
                }
                message={
                  errors.pf_funding_source_consumer_option?.message ??
                  "Invalid input"
                }
              />
            </div>
          </div>
          <div i2c-grid="12">
            <div className="single-field-wrapper">
              <Controller
                name="pf_funding_source_corporate_option"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    {...field}
                    className="centeredCheckbox"
                    label="Loaded by a corporate entity through"
                    onI2cChange={(e) => {
                      if (e.target.value !== "other") {
                        const arr = [
                          "pf_funding_source_corporate_other_company",
                          "pf_funding_source_corporate_other_contact_name",
                          "pf_funding_source_corporate_other_title",
                          "pf_funding_source_corporate_other_phone",
                          "pf_funding_source_corporate_other_phone_country",
                          "pf_funding_source_corporate_other_email",
                          "pf_funding_source_corporate_other_address",
                        ];
                        arr.forEach((field) => methods.setValue(field, ""));
                      }
                      methods.setValue(
                        "pf_funding_source_corporate_option",
                        e.target.value,
                      );
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    <div i2c-grid="grid gap-sm">
                      {corporateFundingSource.map((card, index) => (
                        <I2cListItem
                          key={index}
                          i2c-grid="6@md"
                          variant="receipt"
                          label={card.label}
                          sublabel=""
                          value=""
                          type="checkbox"
                          checked={
                            methods
                              .watch("pf_funding_source_corporate_option")
                              ?.includes(card.value) ?? false
                          }
                        >
                          <I2cRadio
                            slot="prefix"
                            filled
                            checked={
                              methods.watch(
                                "pf_funding_source_corporate_option",
                              ) === card.value
                            }
                            value={card.value}
                          ></I2cRadio>
                        </I2cListItem>
                      ))}
                    </div>
                  </I2cRadioGroup>
                )}
              />
              <ErrorMessage
                show={
                  errors.pf_funding_source_corporate_option &&
                  methods.formState.touchedFields
                    .pf_funding_source_corporate_option
                    ? true
                    : false
                }
                message={
                  errors.pf_funding_source_corporate_option?.message ??
                  "Invalid input"
                }
              />
            </div>
            {methods.watch("pf_funding_source_corporate_option") ===
              "other" && (
              <>
                <div className="mt-16">
                  <div className="custom-label-light mb-12">
                    If using a 3rd Party Vendor, please provide details:
                  </div>
                </div>
                <div i2c-grid="12">
                  <div i2c-grid="grid gap-column-sm gap-row-md">
                    <div i2c-grid="6@md">
                      <div className="single-field-wrapper">
                        <Controller
                          name="pf_funding_source_corporate_other_company"
                          control={control}
                          render={({ field }) => (
                            <I2cInput
                              {...field}
                              name={"pf_funding_source_corporate_other_company"}
                              className="single-input-field"
                              placeholder="Company Name"
                              onI2cInput={(e) => {
                                const value = e.target.value;
                                field.onChange(value);
                                methods.trigger();
                                handleValueChanges();
                                if (value.length === 0) {
                                  methods.setError(
                                    "pf_funding_source_corporate_other_company",
                                    {
                                      message: generalErrorMessage,
                                    },
                                  );
                                } else {
                                }
                              }}
                              required={
                                errors.pf_funding_source_corporate_other_company
                                  ? true
                                  : false
                              }
                              size="large"
                              label="Company Name"
                            />
                          )}
                        />
                        {/* <ErrorMessage
                          show={
                            errors.pf_funding_source_corporate_other_company &&
                            methods.formState.touchedFields
                              .pf_funding_source_corporate_other_company
                              ? true
                              : false
                          }
                          message={
                            errors.pf_funding_source_corporate_other_company
                              ?.message ?? "Invalid input"
                          }
                        /> */}
                      </div>
                    </div>
                    <div i2c-grid="6@md">
                      <div className="single-field-wrapper">
                        <Controller
                          name="pf_funding_source_corporate_other_contact_name"
                          control={control}
                          render={({ field }) => (
                            <I2cInput
                              {...field}
                              name={
                                "pf_funding_source_corporate_other_contact_name"
                              }
                              className="single-input-field"
                              placeholder="Contact Name"
                              onI2cInput={(e) => {
                                const value = e.target.value;
                                field.onChange(value);
                                methods.trigger();
                                handleValueChanges();
                                if (value.length === 0) {
                                  methods.setError(
                                    "pf_funding_source_corporate_other_contact_name",
                                    {
                                      message: generalErrorMessage,
                                    },
                                  );
                                } else {
                                }
                              }}
                              required={
                                errors.pf_funding_source_corporate_other_contact_name
                                  ? true
                                  : false
                              }
                              size="large"
                              label="Contact Name"
                            />
                          )}
                        />
                        {/* <ErrorMessage
                          show={
                            errors.pf_funding_source_corporate_other_contact_name &&
                            methods.formState.touchedFields
                              .pf_funding_source_corporate_other_contact_name
                              ? true
                              : false
                          }
                          message={
                            errors
                              .pf_funding_source_corporate_other_contact_name
                              ?.message ?? "Invalid input"
                          }
                        /> */}
                      </div>
                    </div>
                    <div i2c-grid="6@md">
                      <div className="single-field-wrapper">
                        <Controller
                          name="pf_funding_source_corporate_other_title"
                          control={control}
                          render={({ field }) => (
                            <I2cInput
                              {...field}
                              name={"pf_funding_source_corporate_other_title"}
                              className="single-input-field"
                              placeholder="Job Title"
                              onI2cInput={(e) => {
                                const value = e.target.value;
                                field.onChange(value);
                                methods.trigger();
                                handleValueChanges();
                                if (value.length === 0) {
                                  methods.setError(
                                    "pf_funding_source_corporate_other_title",
                                    {
                                      message: generalErrorMessage,
                                    },
                                  );
                                } else {
                                }
                              }}
                              required={
                                errors.pf_funding_source_corporate_other_title
                                  ? true
                                  : false
                              }
                              size="large"
                              label="Job Title"
                            />
                          )}
                        />
                        {/* <ErrorMessage
                          show={
                            errors.pf_funding_source_corporate_other_title &&
                            methods.formState.touchedFields
                              .pf_funding_source_corporate_other_title
                              ? true
                              : false
                          }
                          message={
                            errors.pf_funding_source_corporate_other_title
                              ?.message ?? "Invalid input"
                          }
                        /> */}
                      </div>
                    </div>
                    <div i2c-grid="6@md">
                      <div className="single-field-wrapper">
                        <I2cPhoneField
                          format="INTERNATIONAL"
                          label="Cell Number"
                          helpIcon=""
                          name="pf_funding_source_corporate_other_phone"
                          size="large"
                          country-box
                          value={methods.watch(
                            "pf_funding_source_corporate_other_phone",
                          )}
                          selectedCountry={methods.watch(
                            "pf_funding_source_corporate_other_phone_country",
                          )}
                          errorMessageVisible={false}
                          onI2cChange={(e) => {
                            const country = e.target.country;
                            const isValid = e.target.isValid;
                            const value = e.target.value;
                            methods.setValue(
                              "pf_funding_source_corporate_other_phone_country",
                              country,
                            );
                            methods.setValue(
                              "pf_funding_source_corporate_other_phone",
                              value,
                            );
                            methods.trigger();
                            handleValueChanges();
                            if (!isValid) {
                              methods.setError(
                                "pf_funding_source_corporate_other_phone",
                                {
                                  message: e.target.guide,
                                },
                              );
                            } else {
                              methods.clearErrors(
                                "pf_funding_source_corporate_other_phone",
                              );
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div i2c-grid="6@md">
                      <div className="single-field-wrapper">
                        <Controller
                          name="pf_funding_source_corporate_other_email"
                          control={control}
                          render={({ field }) => (
                            <I2cInput
                              {...field}
                              name={"pf_funding_source_corporate_other_email"}
                              className="single-input-field"
                              placeholder="Email"
                              onI2cInput={(e) => {
                                const value = e.target.value;
                                field.onChange(value);
                                methods.trigger();
                                handleValueChanges();
                                if (value.length === 0) {
                                  methods.setError(
                                    "pf_funding_source_corporate_other_email",
                                    {
                                      message: generalErrorMessage,
                                    },
                                  );
                                } else {
                                }
                              }}
                              required={
                                errors.pf_funding_source_corporate_other_email
                                  ? true
                                  : false
                              }
                              size="large"
                              label="Email"
                              type="email"
                            />
                          )}
                        />
                        {/* <ErrorMessage
                          show={
                            errors.pf_funding_source_corporate_other_email &&
                            methods.formState.touchedFields
                              .pf_funding_source_corporate_other_email
                              ? true
                              : false
                          }
                          message={
                            errors.pf_funding_source_corporate_other_email
                              ?.message ?? "Invalid input"
                          }
                        /> */}
                      </div>
                    </div>
                    <div i2c-grid="6@md">
                      <div className="single-field-wrapper">
                        <Controller
                          name="pf_funding_source_corporate_other_address"
                          control={control}
                          render={({ field }) => (
                            <I2cTextarea
                              {...field}
                              name={"pf_funding_source_corporate_other_address"}
                              className="single-input-field"
                              placeholder="Physical Address"
                              onI2cInput={(e) => {
                                const value = e.target.value;
                                field.onChange(value);
                                methods.trigger();
                                handleValueChanges();
                                if (value.length === 0) {
                                  methods.setError(
                                    "pf_funding_source_corporate_other_address",
                                    {
                                      message: generalErrorMessage,
                                    },
                                  );
                                } else {
                                }
                              }}
                              required={
                                errors.pf_funding_source_corporate_other_address
                                  ? true
                                  : false
                              }
                              size="large"
                              label="Physical Address"
                              rows={2}
                            />
                          )}
                        />
                        <ErrorMessage
                          show={
                            errors.pf_funding_source_corporate_other_address &&
                            methods.formState.touchedFields
                              .pf_funding_source_corporate_other_address
                              ? true
                              : false
                          }
                          message={
                            errors.pf_funding_source_corporate_other_address
                              ?.message ?? "Invalid input"
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div i2c-grid="grid gap-sm" className="section-space">
          <div i2c-grid="12">
            <span slot="label" className="organize-tooltip">
              <div className="sub-heading">Card Order Placement</div>
              <I2cTooltip
                content="Procedure through which customers will request to order a card and the subsequent channels used to place requests to i2c Inc."
                placement="right-start"
              >
                <I2cIcon label="placement" name="cs-linear-info"></I2cIcon>
              </I2cTooltip>
            </span>
          </div>
          <div i2c-grid="12">
            <I2cRadioGroup
              className="full-list"
              name="cn_card_option"
              onI2cChange={(e) => {
                const value = e.target.value ?? "";
                methods.setValue("pf_card_placement", value);
                methods.setValue("pf_card_placement_channel", []);
                methods.trigger();
                handleValueChanges();
              }}
            >
              <div i2c-grid="grid gap-sm">
                {cardPlacement.map((option, index) => (
                  <I2cListItem
                    key={index}
                    i2c-grid="6@md"
                    variant="receipt"
                    label={option.label}
                    style={{ display: "flex", justifyContent: "space-between" }}
                    sublabel=""
                    className="option-container cardlist-custom-direction"
                    checked={
                      methods.getValues("pf_card_placement") === option.value
                    }
                    type="checkbox"
                  >
                    <I2cRadio
                      slot="prefix"
                      filled
                      checked={
                        methods.getValues("pf_card_placement") === option.value
                      }
                      name="cardOption"
                      value={option.value}
                    ></I2cRadio>
                    <I2cTooltip
                      slot="suffix"
                      hoist
                      content={option.supportText}
                      placement="right-start"
                    >
                      <I2cIcon
                        color="#8e99aa"
                        name="cs-linear-help-circle"
                      ></I2cIcon>
                    </I2cTooltip>
                  </I2cListItem>
                ))}
              </div>
            </I2cRadioGroup>
          </div>
          {methods.watch("pf_card_placement") === "individual-cards" && (
            <div i2c-grid="12">
              <div className="custom-label-light mb-16">
                Select the channels:
              </div>
              <div className="single-field-wrapper">
                <Controller
                  name="pf_card_placement_channel"
                  control={control}
                  render={({ field }) => (
                    <I2cCheckboxGroup
                      {...field}
                      className="centeredCheckbox"
                      label=""
                    >
                      <div i2c-grid="grid gap-sm">
                        {cardChannelIndividual.map((card, index) => (
                          <I2cListItem
                            key={index}
                            i2c-grid="6@md"
                            variant="receipt"
                            label={card.label}
                            sublabel=""
                            value=""
                            type="checkbox"
                            checked={
                              methods
                                .watch("pf_card_placement_channel")
                                ?.includes(card.value) ?? false
                            }
                            onI2cCheckboxClicked={(e) => {
                              handleIndividualsCheckboxGroupChange(card.value);
                              handleValueChanges();
                            }}
                          >
                            <I2cCheckbox
                              slot="prefix"
                              filled
                              value={card.value}
                              checked={
                                methods
                                  .watch("pf_card_placement_channel")
                                  ?.includes(card.value) ?? false
                              }
                              // onI2cChange={(e) => {
                              //   handleIndividualsCheckboxGroupChange(e);
                              //   handleValueChanges();
                              // }}
                              className="customCheckbox"
                            ></I2cCheckbox>
                          </I2cListItem>
                        ))}
                      </div>
                    </I2cCheckboxGroup>
                  )}
                />
                <ErrorMessage
                  show={
                    errors.pf_card_placement_channel &&
                    methods.formState.touchedFields.pf_card_placement_channel
                      ? true
                      : false
                  }
                  message={
                    errors.pf_card_placement_channel?.message ?? "Invalid input"
                  }
                />
              </div>
            </div>
          )}
          {methods.watch("pf_card_placement") === "bulk-order-cards" && (
            <div i2c-grid="12">
              {/* <I2cRadioGroup
                onI2cChange={(e) => setCardChannelValue(e.target.value)}
              >
                {cardChannelBulk.map((radio) => (
                  <I2cRadioButton
                    name="pf_cardChannel"
                    value={radio}
                    label={radio}
                  >
                    {radio}
                  </I2cRadioButton>
                ))}
              </I2cRadioGroup> */}
              <div className="single-field-wrapper">
                <Controller
                  name="pf_card_placement_channel"
                  control={control}
                  render={({ field }) => (
                    <I2cCheckboxGroup
                      {...field}
                      className="centeredCheckbox"
                      label="Select the channels:"
                    >
                      <div i2c-grid="grid gap-sm">
                        {cardChannelBulk.map((card, index) => (
                          <I2cListItem
                            key={index}
                            i2c-grid="6@md"
                            variant="receipt"
                            label={card.label}
                            sublabel=""
                            value=""
                            type="checkbox"
                            checked={
                              methods
                                .watch("pf_card_placement_channel")
                                ?.includes(card.value) ?? false
                            }
                            onI2cCheckboxClicked={(e) => {
                              handleIndividualsCheckboxGroupChange(card.value);
                              handleValueChanges();
                            }}
                          >
                            <I2cCheckbox
                              slot="prefix"
                              filled
                              value={card.value}
                              checked={
                                methods
                                  .watch("pf_card_placement_channel")
                                  ?.includes(card.value) ?? false
                              }
                         
                            ></I2cCheckbox>
                          </I2cListItem>
                        ))}
                      </div>
                    </I2cCheckboxGroup>
                  )}
                />
                <ErrorMessage
                  show={
                    errors.pf_card_placement_channel &&
                    methods.formState.touchedFields.pf_card_placement_channel
                      ? true
                      : false
                  }
                  message={
                    errors.pf_card_placement_channel?.message ?? "Invalid input"
                  }
                />
              </div>
            </div>
          )}
        </div>
        <div i2c-grid="grid gap-sm" className="section-space">
          <div i2c-grid="12">
            <div className="sub-heading">Secondary/Supplementary Cards</div>
          </div>
          <div i2c-grid="6@md">
            <I2cRadioGroup
              label="Are secondary/supplementary cards permitted?"
              onI2cChange={(e) => {
                methods.setValue(
                  "pf_supplimentary_cards_permitted",
                  e.target.value,
                );
                if (e.target.value === "no") {
                  const arr = [
                    "supplimentary_cards_own_profile",
                    "supplimentary_cards_share_primary_balance",
                  ];
                  arr.forEach((field) => methods.setValue(field, ""));
                }
                methods.trigger();
                handleValueChanges();
              }}
              value={methods.watch("pf_supplimentary_cards_permitted")}
            >
              {secondaryCardOption.map((radio, index) => (
                <I2cRadioButton
                  key={index}
                  value={radio.toLocaleLowerCase()}
                  label={radio}
                >
                  {radio}
                </I2cRadioButton>
              ))}
            </I2cRadioGroup>
          </div>
          <div i2c-grid="6@md">
            <I2cRadioGroup
              label="Is the seconday supplementary card 18+?"
              onI2cChange={(e) => {
                methods.setValue(
                  "pf_supplimentary_cards_age_limit",
                  e.target.value,
                );
                methods.trigger();
                handleValueChanges();
              }}
              value={methods.watch("pf_supplimentary_cards_age_limit")}
            >
              {secondaryCardOption.map((radio, index) => (
                <I2cRadioButton
                  key={index}
                  value={radio.toLocaleLowerCase()}
                  label={radio}
                >
                  {radio}
                </I2cRadioButton>
              ))}
            </I2cRadioGroup>
          </div>
          {methods.watch("pf_supplimentary_cards_permitted") === "yes" && (
            <>
              <div i2c-grid="6@md">
                <I2cRadioGroup
                  label="Will the secondary cards have their own profile?"
                  onI2cChange={(e) => {
                    methods.setValue(
                      "supplimentary_cards_own_profile",
                      e.target.value,
                    );
                    methods.trigger();
                    handleValueChanges();
                  }}
                  value={methods.watch("supplimentary_cards_own_profile")}
                >
                  {ownProfile.map((radio, index) => (
                    <I2cRadioButton
                      key={index}
                      name="pf_ownProfile"
                      value={radio.toLocaleLowerCase()}
                      label={radio}
                      checked={
                        methods.watch("supplimentary_cards_own_profile") ===
                        radio.toLocaleLowerCase()
                      }
                    >
                      {radio}
                    </I2cRadioButton>
                  ))}
                </I2cRadioGroup>
              </div>
              <div i2c-grid="6@md">
                <I2cRadioGroup
                  label="If Yes, will they share balance with the Primary Card?"
                  onI2cChange={(e) => {
                    methods.setValue(
                      "supplimentary_cards_share_primary_balance",
                      e.target.value,
                    );
                    methods.trigger();
                    handleValueChanges();
                  }}
                  value={methods.watch(
                    "supplimentary_cards_share_primary_balance",
                  )}
                >
                  {shareBalance.map((radio, index) => (
                    <I2cRadioButton
                      key={index}
                      value={radio.toLocaleLowerCase()}
                      label={radio}
                      checked={
                        methods.watch(
                          "supplimentary_cards_share_primary_balance",
                        ) === radio.toLocaleLowerCase()
                      }
                    >
                      {radio}
                    </I2cRadioButton>
                  ))}
                </I2cRadioGroup>
              </div>
            </>
          )}
        </div>
        <div i2c-grid="grid gap-sm" className="section-space">
          <div i2c-grid="12">
            <div className="sub-heading">Activation Required?</div>
          </div>
          <div i2c-grid="12">
            <I2cRadioGroup
              onI2cChange={(e) => {
                methods.setValue("pf_card_activation_required", e.target.value);
                if (e.target.value === "yes") {
                  methods.setValue("pf_card_activation_method", "");
                } else {
                  methods.setValue("pf_card_activation_channels", []);
                  methods.setValue("pf_card_activation_channels_other", "");
                }
                methods.trigger();
                handleValueChanges();
              }}
              value={methods.watch("pf_card_activation_required")}
            >
              {shareBalance.map((radio, index) => (
                <I2cRadioButton
                  key={index}
                  value={radio.toLocaleLowerCase()}
                  label={radio}
                >
                  {radio}
                </I2cRadioButton>
              ))}
            </I2cRadioGroup>
          </div>
        </div>
        {methods.watch("pf_card_activation_required") === "no" && (
          <div i2c-grid="grid gap-sm" className="section-space">
            <div i2c-grid="12">
              <div className="sub-heading">Card Activation Method</div>
            </div>
            <div i2c-grid="12">
              <I2cRadioGroup
                name="cn_card_option"
                onI2cChange={(e) => {
                  const value = e.target.value ?? "";
                  methods.setValue("pf_card_activation_method", value);
                  methods.trigger();
                  handleValueChanges();
                }}
              >
                <div i2c-grid="grid gap-sm">
                  {cardActivationMethod.map((option, index) => (
                    <I2cListItem
                      key={index}
                      i2c-grid="6@md"
                      variant="receipt"
                      label={option.label}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                      sublabel=""
                      className="option-container"
                      checked={
                        methods.getValues("pf_card_activation_method") ===
                        option.value
                      }
                      type="checkbox"
                    >
                      <I2cRadio
                        slot="prefix"
                        filled
                        checked={
                          methods.getValues("pf_card_activation_method") ===
                          option.value
                        }
                        name="cardOption"
                        value={option.value}
                      ></I2cRadio>
                    </I2cListItem>
                  ))}
                </div>
              </I2cRadioGroup>
            </div>
          </div>
        )}
        {methods.watch("pf_card_activation_required") === "yes" && (
          <div i2c-grid="grid gap-sm" className="section-space">
            <div i2c-grid="12">
              <div className="sub-heading mb-4">Card Activation Channels</div>
              <div className="custom-label-light">
                Select the i2c Inc. channels/interfaces you want the cardholders
                to use to activate card accounts.
              </div>
            </div>
            <div i2c-grid="12">
              <I2cCheckboxGroup ref={cardActivation}>
                <div i2c-grid="grid gap-sm">
                  {cardsActivationChannel.map((card, index) => (
                    <div key={index} i2c-grid="6@md">
                      <I2cListItem
                        variant="receipt"
                        label={card.label}
                        sublabel=""
                        value=""
                        type="checkbox"
                        checked={
                          methods
                            .watch("pf_card_activation_channels")
                            ?.includes(card.value) ?? false
                        }
                        onI2cCheckboxClicked={(e) => {
                          handleCardActivationChannel(card.value);
                          handleValueChanges();
                        }}
                      >
                        <I2cCheckbox
                          slot="prefix"
                          value={card.value}
                          label=""
                          filled
                          ignoreTab
                          checked={
                            methods
                              .watch("pf_card_activation_channels")
                              ?.includes(card.value) ?? false
                          }
                        
                          className="customCheckbox"
                        ></I2cCheckbox>
                      </I2cListItem>
                    </div>
                  ))}
                </div>
              </I2cCheckboxGroup>
            </div>
            {methods.watch("pf_card_activation_channels").includes("other") && (
              <div i2c-grid="6@md">
                <div className="single-field-wrapper">
                  <Controller
                    name="pf_card_activation_channels_other"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        name={"pf_card_activation_channels_other"}
                        className="single-input-field"
                        placeholder="Please Specify"
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                          if (value.length === 0) {
                            methods.setError(
                              "pf_card_activation_channels_other",
                              {
                                message: generalErrorMessage,
                              },
                            );
                          } else {
                          }
                        }}
                        required={
                          errors.pf_card_activation_channels_other
                            ? true
                            : false
                        }
                        size="large"
                        label="Please Specify"
                      />
                    )}
                  />
                  {/* <ErrorMessage
                    show={
                      errors.pf_card_activation_channels_other &&
                      methods.formState.touchedFields
                        .pf_card_activation_channels_other
                        ? true
                        : false
                    }
                    message={
                      errors.pf_card_activation_channels_other?.message ??
                      "Invalid input"
                    }
                  /> */}
                </div>
              </div>
            )}
          </div>
        )}
        <div i2c-grid="grid gap-sm" className="section-space">
          <div i2c-grid="12">
            <div className="sub-heading mb-4">Offline PIN</div>
            <I2cRadioGroup
              label="Confirm if offline PIN support is required"
              onI2cChange={(e) => {
                methods.setValue(
                  "pf_card_offline_pin_required",
                  e.target.value,
                );
                methods.trigger();
                handleValueChanges();
              }}
              className="mb-16"
            >
              {offlinePin.map((radio, index) => (
                <I2cRadioButton
                  key={index}
                  checked={
                    methods.watch("pf_card_offline_pin_required") ===
                    radio.toLocaleLowerCase()
                  }
                  value={radio.toLocaleLowerCase()}
                  label={radio}
                >
                  {radio}
                </I2cRadioButton>
              ))}
            </I2cRadioGroup>
          </div>
        </div>
        <div i2c-grid="grid gap-sm" className="section-space">
          <div i2c-grid="12">
            <span slot="label" className="organize-tooltip">
              <div className="sub-heading">Cardholder Notifications</div>
              <I2cTooltip
                content="Notifications can be managed by i2c Inc. platform, based upon client notification content and scheduling parameters with notifications being send directly to Cardholders.
              Alternatively, these can be managed by the client outside of the i2c Inc. platform, data in this case can be shared through SMPP Setup/Push Alerts."
                placement="right-start"
              >
                <I2cIcon label="placement" name="cs-linear-info"></I2cIcon>
              </I2cTooltip>
            </span>
          </div>
          <div i2c-grid="12">
            <I2cRadioGroup
              ref={cardActivation}
              onI2cChange={(e) => {
                methods.setValue("pf_cardholder_notifications", e.target.value);
                methods.setValue("pf_cardholder_notifications_channels", "");
                methods.trigger();
                handleValueChanges();
              }}
            >
              <div i2c-grid="grid gap-sm">
                {cardholderNotify.map((card, index) => (
                  <div key={index} i2c-grid="6@md">
                    <I2cListItem
                      variant="receipt"
                      label={card.label}
                      sublabel=""
                      value=""
                      type="checkbox"
                      checked={
                        methods.watch("pf_cardholder_notifications") ===
                        card.value
                      }
                    >
                      <I2cRadio
                        slot="prefix"
                        label=""
                        filled
                        ignoreTab
                        checked={
                          methods.watch("pf_cardholder_notifications") ===
                          card.value
                        }
                        value={card.value}
                      ></I2cRadio>
                    </I2cListItem>
                  </div>
                ))}
              </div>
            </I2cRadioGroup>
          </div>
          {methods.watch("pf_cardholder_notifications").length > 0 ? (
            <div i2c-grid="12">
              <I2cRadioGroup
                ref={cardActivation}
                label="Select the channel through which alerts data will be shared."
                onI2cChange={(e) => {
                  methods.setValue(
                    "pf_cardholder_notifications_channels",
                    e.target.value,
                  );
                  methods.trigger();
                  handleValueChanges();
                }}
              >
                {methods.watch("pf_cardholder_notifications") !==
                "send-to-holders" ? (
                  [
                    { label: "PUSH", value: "push" },
                    { label: "SMPP", value: "smpp" },
                  ].map((type, index) => (
                    <I2cRadioButton
                      key={index}
                      checked={
                        methods.watch(
                          "pf_cardholder_notifications_channels",
                        ) === type.value
                      }
                      value={type.value}
                    >
                      {type?.label}
                    </I2cRadioButton>
                  ))
                ) : (
                  <div i2c-grid="grid gap-sm">
                    {notificationChannels.map((card, index) => (
                      <div key={index} i2c-grid="4@md">
                        <I2cListItem
                          variant="receipt"
                          label={card?.label}
                          sublabel=""
                          value=""
                          type="checkbox"
                          checked={
                            methods.watch(
                              "pf_cardholder_notifications_channels",
                            ) === card.value
                          }
                        >
                          <I2cRadio
                            slot="prefix"
                            filled
                            checked={
                              methods.watch(
                                "pf_cardholder_notifications_channels",
                              ) === card.value
                            }
                            value={card.value}
                          ></I2cRadio>
                        </I2cListItem>
                      </div>
                    ))}
                  </div>
                )}
              </I2cRadioGroup>
            </div>
          ) : null}
        </div>
        <div i2c-grid="grid gap-sm">
          <div i2c-grid="12">
            <div className="sub-heading mb-4">Customer Support Channel</div>
            <div className="custom-label-light mb-16">
              Please confirm what customer support will be available to the
              cardholders
            </div>
            <I2cCheckboxGroup ref={cardActivation} label="">
              <div i2c-grid="grid gap-sm">
                {customerSupportChannel.map((card, index) => (
                  <div key={index} i2c-grid="6@md">
                    <I2cListItem
                      variant="receipt"
                      label={card.label}
                      sublabel=""
                      value=""
                      type="checkbox"
                      checked={
                        methods
                          .watch("pf_customer_support_channels")
                          ?.includes(card.value) ?? false
                      }
                      onI2cCheckboxClicked={(e) => {
                        handleCustomerSupportChannels(card.value);
                        handleValueChanges();
                      }}
                    >
                      <I2cCheckbox
                        slot="prefix"
                        value={card.value}
                        label=""
                        filled
                        ignoreTab
                        checked={
                          methods
                            .watch("pf_customer_support_channels")
                            ?.includes(card.value) ?? false
                        }
                     
                        className="customCheckbox"
                      ></I2cCheckbox>
                    </I2cListItem>
                  </div>
                ))}
              </div>
            </I2cCheckboxGroup>
          </div>
          <div i2c-grid="12">
            <div className="custom-label-light mb-16">
              Who will provide customer support?
            </div>
            <I2cRadioGroup
              label=""
              name="cn_card_option"
              onI2cChange={(e) => {
                const value = e.target.value ?? "";
                methods.setValue("pf_customer_support_provider", value);
                if (value !== "other") {
                  const arr = [
                    "pf_customer_support_provider_other_company",
                    "pf_customer_support_provider_other_contact_name",
                    "pf_customer_support_provider_other_title",
                    "pf_customer_support_provider_other_phone",
                    "pf_customer_support_provider_other_phone_country",
                    "pf_customer_support_provider_other_email",
                  ];
                  arr.forEach((field) => methods.setValue(field, ""));
                }
                methods.trigger();
                handleValueChanges();
              }}
            >
              <div i2c-grid="grid gap-sm">
                {customerSupportProviders.map((option, index) => (
                  <I2cListItem
                    key={index}
                    i2c-grid="6@md"
                    variant="receipt"
                    label={option.label}
                    style={{ display: "flex", justifyContent: "space-between" }}
                    sublabel=""
                    className="option-container"
                    checked={
                      methods.getValues("pf_customer_support_provider") ===
                      option.value
                    }
                    type="checkbox"
                  >
                    <I2cRadio
                      slot="prefix"
                      filled
                      checked={
                        methods.getValues("pf_customer_support_provider") ===
                        option.value
                      }
                      name="cardOption"
                      value={option.value}
                    ></I2cRadio>
                  </I2cListItem>
                ))}
              </div>
            </I2cRadioGroup>
          </div>
          {methods.watch("pf_customer_support_provider") ===
            "client-third-party" && (
            <div i2c-grid="12">
              <div className="custom-label-light mb-12 mt-8">
                If using a 3rd Party Vendor, please provide details:
              </div>
              <div i2c-grid="grid gap-column-sm gap-row-md">
                <div i2c-grid="6@md">
                  <div className="single-field-wrapper">
                    <Controller
                      name="pf_customer_support_provider_other_company"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          name={"pf_customer_support_provider_other_company"}
                          className="single-input-field"
                          placeholder="Company Name"
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            handleValueChanges();
                            if (value.length === 0) {
                              methods.setError(
                                "pf_customer_support_provider_other_company",
                                {
                                  message: generalErrorMessage,
                                },
                              );
                            } else {
                            }
                          }}
                          required
                          size="large"
                          label="Name"
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.pf_customer_support_provider_other_company &&
                        methods.formState.touchedFields
                          .pf_customer_support_provider_other_company
                          ? true
                          : false
                      }
                      message={
                        errors.pf_customer_support_provider_other_company
                          ?.message ?? "Invalid input"
                      }
                    /> */}
                  </div>
                </div>
                <div i2c-grid="6@md">
                  <div className="single-field-wrapper">
                    <Controller
                      name="pf_customer_support_provider_other_title"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          name={"pf_customer_support_provider_other_title"}
                          className="single-input-field"
                          placeholder="Job Title"
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);

                            methods.trigger();
                            handleValueChanges();
                            if (value.length === 0) {
                              methods.setError(
                                "pf_customer_support_provider_other_title",
                                {
                                  message: generalErrorMessage,
                                },
                              );
                            } else {
                            }
                          }}
                          required
                          // required={
                          //   errors.pf_customer_support_provider_other_title
                          //     ? true
                          //     : false
                          // }
                          size="large"
                          label="Job Title"
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.pf_customer_support_provider_other_title &&
                        methods.formState.touchedFields
                          .pf_customer_support_provider_other_title
                          ? true
                          : false
                      }
                      message={
                        errors.pf_customer_support_provider_other_title
                          ?.message ?? "Invalid input"
                      }
                    /> */}
                  </div>
                </div>

                <div i2c-grid="6@md">
                  <div className="single-field-wrapper">
                    <Controller
                      name="pf_customer_support_provider_other_email"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          name={"pf_customer_support_provider_other_email"}
                          className="single-input-field"
                          placeholder="Email"
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);

                            methods.trigger();
                            handleValueChanges();
                            if (value.length === 0) {
                              methods.setError(
                                "pf_customer_support_provider_other_email",
                                {
                                  message: generalErrorMessage,
                                },
                              );
                            } else {
                            }
                          }}
                          required
                          type="email"
                          // required={
                          //   errors.pf_customer_support_provider_other_email
                          //     ? true
                          //     : false
                          // }
                          size="large"
                          label="Email"
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.pf_customer_support_provider_other_email &&
                        methods.formState.touchedFields
                          .pf_customer_support_provider_other_email
                          ? true
                          : false
                      }
                      message={
                        errors.pf_customer_support_provider_other_email
                          ?.message ?? "Invalid input"
                      }
                    /> */}
                  </div>
                </div>
                <div i2c-grid="6@md">
                  <div className="single-field-wrapper">
                    <I2cPhoneField
                      format="INTERNATIONAL"
                      label="Phone"
                      helpIcon=""
                      name="pf_customer_support_provider_other_phone"
                      size="large"
                      required
                      country-box
                      value={methods.watch(
                        "pf_customer_support_provider_other_phone",
                      )}
                      selectedCountry={methods.watch(
                        "pf_customer_support_provider_other_phone_country",
                      ) || "US"  }
                      errorMessageVisible={false}
                      onI2cChange={(e) => {
                        const country = e.target.country;
                        const isValid = e.target.isValid;
                        const value = e.target.value;
                        methods.setValue(
                          "pf_customer_support_provider_other_phone_country",
                          country,
                        );
                        methods.setValue(
                          "pf_customer_support_provider_other_phone",
                          value,
                        );

                        methods.trigger();
                        handleValueChanges();
                        if (!isValid) {
                          methods.setError(
                            "pf_customer_support_provider_other_phone",
                            {
                              message: e.target.guide,
                            },
                          );
                        } else {
                          methods.clearErrors(
                            "pf_customer_support_provider_other_phone",
                          );
                        }
                      }}
                    />
                  </div>
                </div>
                <div i2c-grid="6@md">
                  <div className="single-field-wrapper">
                    <Controller
                      name="pf_customer_support_provider_other_contact_name"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          name={
                            "pf_customer_support_provider_other_contact_name"
                          }
                          className="single-input-field"
                          placeholder="Contact Name"
                          required
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);

                            methods.trigger();
                            handleValueChanges();
                            if (value.length === 0) {
                              methods.setError(
                                "pf_customer_support_provider_other_contact_name",
                                {
                                  message: generalErrorMessage,
                                },
                              );
                            } else {
                            }
                          }}
                          // required={
                          //   errors.pf_customer_support_provider_other_contact_name
                          //     ? true
                          //     : false
                          // }
                          size="large"
                          label="Company Name"
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.pf_customer_support_provider_other_contact_name &&
                        methods.formState.touchedFields
                          .pf_customer_support_provider_other_contact_name
                          ? true
                          : false
                      }
                      message={
                        errors.pf_customer_support_provider_other_contact_name
                          ?.message ?? "Invalid input"
                      }
                    /> */}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* <I2cRadioGroup
            name="cn_card_option"
            onI2cChange={(e) => {
              const value = e.target.value ?? "";
              methods.setValue("pf_card_placement", value);
            }}
          >
            <div i2c-grid="grid gap-sm">
              {cardholderNotify.map((option) => (
                <I2cListItem
                  i2c-grid="6@md"
                  variant="receipt"
                  label={option.label}
                  style={{ display: "flex", justifyContent: "space-between" }}
                  sublabel=""
                  className="option-container"
                  checked={methods.getValues("pf_card_placement") === option.value}
                  type="checkbox"
                >
                  <I2cRadio
                    slot="prefix"
                    filled
                    checked={
                      methods.getValues("pf_card_placement") === option.value
                    }
                    name="cardOption"
                    value={option.value}
                  ></I2cRadio>
                </I2cListItem>
              ))}
            </div>
          </I2cRadioGroup> */}
      </div>
    </React.Fragment>
  );
};

export default ProgramFeatures;
